<script setup>
import { UserDetails } from '@lib/pp-shop-lib/components';
import { useAuthStore } from '@lib/pp-shop-lib/stores';
import { watch } from 'vue';
import { useRouter } from 'vue-router';

const authStore = useAuthStore()
const router = useRouter()

watch(
    () => Boolean(authStore.user?.token || authStore.user?.kid),
    (isLoggedIn) => {
        if (!isLoggedIn) {
            router.replace('/shop/account/login')
        }
    },
    { immediate: true }
)
</script>

<template>
    <UserDetails />
</template>
